/* eslint-disable no-unused-expressions */
import { Icon } from '@iconify/react'

interface Props {
    currentPage: number
    handlePageMinus: () => void
    handlePagePlus: () => void
    disabledNext: boolean
}

const Pagination = ({ currentPage, handlePageMinus, handlePagePlus, disabledNext }: Props) => {
    return (
        <div className="w-full gap-3 py-4 flex-center pagination">
            <Icon
                icon="ic:round-arrow-back"
                className={`text-pri text-[20px] cursor-pointer ${
                    currentPage === 1 && 'opacity-[0.5] cursor-not-allowed'
                }`}
                onClick={handlePageMinus}
            />
            <div className="text-sm">Page {currentPage}</div>
            <Icon
                icon="ic:round-arrow-back"
                className={`rotate-[180deg] text-pri text-[20px] cursor-pointer ${
                    disabledNext && 'opacity-[0.5] cursor-not-allowed'
                }`}
                onClick={handlePagePlus}
            />
        </div>
    )
}

export default Pagination
